import { forwardRef } from 'react';
import { AlertProps } from './types';
import clsx from 'clsx';
import IconButton from '../IconButton';
import IconClose from '../../icons/IconClose';

/**
 *  UI Component
 */
const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  // Apply Default props values
  props = {
    ...{
      color: undefined,
      size: undefined,
      rounded: true
    },
    ...props
  };

  const {
    className,
    children,
    color,
    size,
    onClose,
    fullWidth,
    rounded,
    raised,
    icon,
    variant,
    ...rest
  } = props;

  const cls = styleAlert(props);
  return (
    <div className={clsx(cls.main, className)} ref={ref} {...rest}>
      {icon && <span className={clsx(cls.icon)}>{icon}</span>}
      <span className={clsx(cls.inner)}>{children}</span>
      {onClose && (
        <IconButton
          onClick={onClose}
          variant="text"
          rounded="full"
          className={clsx(cls.close)}
        >
          <IconClose />
        </IconButton>
      )}
    </div>
  );
});

export default Alert;

/**
 * Assign classNames to component based on properties
 */
function styleAlert(props: AlertProps) {
  const mc = 'Alert';
  const cls = {
    main: [mc],
    inner: [`${mc}__Inner`],
    icon: [`${mc}__Icon`],
    close: [`${mc}__Close`]
  };
  if (props.color) {
    cls.main.push(`${mc}--${props.color}`);
  }
  if (props.size) {
    cls.main.push(`${mc}--${props.size}`);
  }
  if (props.fullWidth) {
    cls.main.push(`${mc}--fullWidth`);
  }
  if (props.rounded) {
    cls.main.push(`${mc}--rounded`);
  }
  if (props.raised) {
    cls.main.push(`${mc}--raised`);
  }
  if (props.variant) {
    cls.main.push(`${mc}--${props.variant}`);
  }
  return cls;
}
